if (!('container' in document.documentElement.style)) {
  void import(/* webpackChunkName: "container-query" */ 'container-query-polyfill');
}
